import { experimentsTrackEvent } from '../../experiments/eventTracking'
import {
  type RecommendationAttributionContext,
  recommendationAttributionGetProductType,
  recommendationAttributionRecordClick,
  type RecommendationProductTypeContext,
} from '../../experiments/recommendation-attribution'

type RecommendationExperimentsTrackRecommendationEventParams = {
  attribution?: RecommendationAttributionContext
  eventKey: string
  offerId?: string
  productTypeContext?: RecommendationProductTypeContext
  serviceId?: string
  widgetId?: string
}

const buildRecommendationTrackEventTags = ({
  productType,
  serviceId,
  widgetId,
}: {
  productType?: string
  serviceId: string
  widgetId: string
}): Record<string, Record<string, string>> => ({
  $opt_event_properties: {
    areaId: widgetId,
    ...(productType && { productType }),
    serviceId,
  },
})

export const recommendationExperimentsTrackRecommendationEvent = ({
  attribution,
  eventKey,
  offerId,
  productTypeContext,
  serviceId,
  widgetId,
}: RecommendationExperimentsTrackRecommendationEventParams): void => {
  if (!widgetId || !serviceId) {
    return
  }

  const productTypeSource = attribution ?? productTypeContext
  const productType = productTypeSource
    ? recommendationAttributionGetProductType(productTypeSource)
    : undefined

  if (attribution) {
    recommendationAttributionRecordClick({
      areaId: widgetId,
      ...attribution,
      interactionType: 'product-click',
      offerId,
      serviceId,
    })
  }

  experimentsTrackEvent(
    eventKey,
    buildRecommendationTrackEventTags({
      productType,
      serviceId,
      widgetId,
    }),
  )
}
